module.exports = __webpack_public_path__ + "352cc77aaed5208ce13c79cf9c89892f.woff2";